import { useEffect } from "react";

const LOGO_SRC = "/images/partners/crossroots-mma.png";
const LOGO_ALT = "Crossroots MMA";

function addBadge(card, variant) {
  if (!card || card.querySelector(`.crossroots-partner-badge--${variant}`)) return;

  const badge = document.createElement("div");
  badge.className = `crossroots-partner-badge crossroots-partner-badge--${variant}`;
  badge.setAttribute("aria-label", LOGO_ALT);

  const image = document.createElement("img");
  image.src = LOGO_SRC;
  image.alt = LOGO_ALT;
  image.loading = "eager";

  badge.appendChild(image);
  card.appendChild(badge);
}

function secondCard(selector) {
  return document.querySelectorAll(selector)[1] || null;
}

function ensureCrossrootsBranding() {
  // Silver Coast / Thalwil is the second dojo throughout the homepage data model.
  // Targeting by position avoids breakage when the localized heading changes.
  addBadge(secondCard("#dojos .dojo-card"), "dojo");
  addBadge(secondCard("#contact .map-card"), "map");
}

export default function CrossrootsBranding() {
  useEffect(() => {
    ensureCrossrootsBranding();

    const root = document.getElementById("root");
    if (!root) return undefined;

    const observer = new MutationObserver(ensureCrossrootsBranding);
    observer.observe(root, { childList: true, subtree: true });

    return () => observer.disconnect();
  }, []);

  return null;
}
